<template>
  <div>
    <!-- 顶部导航 -->
    <TopNav></TopNav>
    <!-- 停车充电轮播图 -->
    <ParkingBanner></ParkingBanner>
    <!-- 智能停车系统描述 -->
    <ParkingDescribe></ParkingDescribe>
    <!-- 道闸列表 -->
    <ParkingList></ParkingList>
    <!-- 核心功能 -->
    <ParkingCore></ParkingCore>
    <!-- 底部导航 -->
    <ButtonNav></ButtonNav>
  </div>
</template>

<script>
import { reactive } from "vue";

import TopNav from "../../../../components/pc/components/TopNav.vue";
import ButtonNav from "../../../../components/pc/components/BottomNav.vue";
import ParkingBanner from '../../../../components/pc/Programme/ParkingComponents/ParkingBanner.vue'
import ParkingDescribe from '../../../../components/pc/Programme/ParkingComponents/ParkingDescribe.vue'
import ParkingList from '../../../../components/pc/Programme/ParkingComponents/ParkingList.vue'
import ParkingCore from '../../../../components/pc/Programme/ParkingComponents/ParkingCore.vue'

export default {
  setup() {
    return reactive({});
  },
  components: {
    TopNav,
    ButtonNav,
    ParkingBanner,
    ParkingDescribe,
    ParkingList,
    ParkingCore,
  },
};
</script>

<style scoped>
</style>
